import React from "react";
import {ListItem, ListItemText, Typography} from "@mui/material";

export default function ListItemReversedTextView({title, content, divider = true} : {title: string | React.ReactNode, content: string | React.ReactNode, divider?: boolean}) {
    return (
        <ListItem divider={divider}>
            <ListItemText
                primary={(
                    <Typography color={"textSecondary"}>
                        {title}
                    </Typography>
                )}
                secondary={(
                    <Typography color={"textPrimary"}>
                        {content}
                    </Typography>
                )}
            />
        </ListItem>
    )

}